// 대만 지명
// 검색 0건 폴백 지명 사전의 tw 항목. 규약·운영 규칙은 ./index.ts 헤더 참고.
// 지우펀(九份)·시먼딩·스린 야시장 등은 HOT_SPOTS(config/locations)에 이미 있다.
import type { SearchPlace } from "./index";

export const TW_PLACES: SearchPlace[] = [
  {
    id: "TW-NWT-SHIFEN",
    cityId: "TW-NWT",
    names: ["스펀", "shifen", "十分", "十分老街", "스펀 폭포", "十分瀑布", "핑시", "平溪", "pingxi"],
    coordinates: { latitude: 25.0434, longitude: 121.7756 },
  },
  {
    id: "TW-NWT-YEHLIU",
    cityId: "TW-NWT",
    names: ["예류", "yehliu", "yeliu", "野柳", "예류 지질공원", "野柳地質公園", "野柳地质公园"],
    coordinates: { latitude: 25.2066, longitude: 121.6905 },
  },
  {
    id: "TW-TPE-SONGSHAN-AIRPORT",
    cityId: "TW-TPE",
    names: ["쑹산공항", "송산공항", "songshan airport", "tsa airport", "松山機場", "松山机场", "台北松山空港"],
    coordinates: { latitude: 25.0694, longitude: 121.5525 },
  },
];
